module.exports = __webpack_public_path__ + "img/13.1b69302a.jpg";